import React from 'react';
import Markdown from 'react-markdown';
import { SourceInfo } from '../../TextMessage';
import styles from './SourceCard.module.scss';
import classNames from 'classnames/bind';
import { Card, Typography } from 'gd-design-library';

const cx = classNames.bind(styles);

const CN = 'source-card';

interface SourceCardProps {
  source: SourceInfo;
  withBorder?: boolean;
}

export const SourceCard = ({ source, withBorder }: SourceCardProps): React.ReactElement => {
  const handleClick = (): void => {
    const { hash } = new URL(source.link);
    const faqLink = `/faq${hash}`;
    window.open(faqLink, '_blank');
  };

  return (
    <Card
      role='button'
      onClick={ handleClick }
      className={ cx(CN, { [`${CN}--bordered`]: withBorder }) }
    >
      <Typography variant='strong'>
        <Markdown>{source.title}</Markdown>
      </Typography>
      <Typography variant='caption'>
        <Markdown>{source.body}</Markdown>
      </Typography>
    </Card>
  );
};
